import { AxiosError } from "axios";

import { NotificationToast } from "../components/Generic/Toast/NotificationToast";
import { Error } from "../models/error";
import { TypeError } from "./enums";

export const checkError = (
  axiosError: AxiosError<Error>,
  defaultMessage: string,
  messageId?: string
) => {
  const error: Error | null =
    axiosError && axiosError?.response && axiosError?.response?.data
      ? axiosError?.response?.data
      : null;

  const isErrorWithoutToast = error?.type === TypeError.ERROR_WITHOUT_TOAST;

  if (isErrorWithoutToast) return;

  let messageDisplayed = defaultMessage;

  if (error) {
    if (error?.message) messageDisplayed = error.message;
    switch (error?.type) {
      case TypeError.ERROR:
        NotificationToast.error(messageDisplayed, { id: messageId });
        break;
      case TypeError.INFO:
        NotificationToast.info(messageDisplayed, { id: messageId });
        break;
      case TypeError.SUCCESS:
        NotificationToast.success(messageDisplayed, { id: messageId });
        break;
      case TypeError.WARNING:
        NotificationToast.warning(messageDisplayed, { id: messageId });
        break;
      default:
        NotificationToast.error(messageDisplayed, { id: messageId });
        break;
    }
  } else {
    NotificationToast.error(messageDisplayed, { id: messageId });
  }
};
